<template>
  <div class="top-padding">
    <div class="page-top" v-if="hasTitle">
      <div class="page-top-inner-wrap">
        <h2 class="page-title" tabindex="0">고객센터</h2>
      </div>
    </div>

    <div class="wrap" v-if="type === 'notice'">
      <div class="cs-body">
        <header-tab></header-tab>
        <router-view name="customerContent" :key="'customer_'+ $router.name"></router-view>
      </div>
    </div>
    <div v-if="type === 'event'">
      <event-header></event-header>
      <router-view name="customerContent" :key="'customer_'+ $router.name + componentKey"></router-view>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import HeaderTab from '@/components/customer/HeaderTab'
import EventHeader from '@/components/customer/EventHeader'
import { SET_CURRENT_MENU, UPDATE_EVENT_LIST_CONTENT } from '@/common/resources/const'
import { mapMutations } from 'vuex'

export default {
  name: 'app',
  components: {
    HeaderTab,
    EventHeader
  },
  data () {
    return {
      componentKey: 0
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU])
  },
  computed: {
    type () {
      return this.$route.meta.type
    },
    hasTitle () {
      const routeName = _.get(this.$route, 'name', '')
      return routeName !== 'event_list' &&
        routeName !== 'event_board_list' &&
        routeName !== 'event_board_view' &&
        routeName !== 'event_view'
    }
  },
  mounted () {
    this[SET_CURRENT_MENU]('customer')
    this.$events.$on(UPDATE_EVENT_LIST_CONTENT, () => {
      this.componentKey += 1
    })
  },
  beforeDestroy () {
    this.$events.$off(UPDATE_EVENT_LIST_CONTENT)
  }
}
</script>
<style lang="css" src="@/assets/css/member.css"></style>
<style lang="css" src="@/assets/css/customer.css"></style>
